var exports = {
  "kL": "container__qcj0r_",
  "rf": "body__fphukB",
  "xd": "editHistory__7RHqq5",
  "eu": "editMetadata__ws0CPo",
  "r9": "editButton__kkP1ND",
};

module.exports = exports;
